<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :esg-subscription="esgSubscription"
    :prices-assessment-subscription="subscription"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :esg-subscription="esgSubscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  NATURAL_GRAPHITE,
  MARKET,
  SUBSCRIPTION_FORECASTS_NATURAL_GRAPHITE,
  SUBSCRIPTION_ESG_NATURAL_GRAPHITE,
  SUBSCRIPTION_PRICE_ASSESSMENTS_NATURAL_GRAPHITE,
} from '~/constants/services/constants'
import naturalGraphiteData from '~/constants/data-reports/natural-graphite'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(NATURAL_GRAPHITE)
const productData = ref(naturalGraphiteData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_NATURAL_GRAPHITE)
const esgSubscription = ref(SUBSCRIPTION_ESG_NATURAL_GRAPHITE)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_NATURAL_GRAPHITE)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${NATURAL_GRAPHITE.name} Data and Reports`,
})
useHead(seo)
</script>
